<template>
  <v-container fluid class="ma-0 pa-0">
    <v-col class="ma-0 pa-0" cols="12">
      <Header title="Video Test" />
      <v-col class="ma-0 pa-0" cols="12">
        <v-col class="pa-0" id="main_content_minwidthset" cols="12">
          <v-row class="ma-0 pa-0" align="start">
            <v-col id="main_content" class="ma-0 pa-10" cols="12">
              <v-row class="ma-0 pa-0" align="start" justify="center">
                <v-col id="video_box" class="pa-0" cols="8" align="center">
                  <video id="video1" height=500
                    style="object-fit: fill;width:100%;height:100%;cursor: default;"
							  		class="video-js vjs-default-skin vjs-big-play-centered vjs-current-time vjs-control-bar" 
							  		crossorigin="anonymous" 
							  	></video>
									<div id="zoom_change" @mouseover="hoverZoom()" @mouseout="hoverOutZoom()">
										<v-img max-height="1.5rem" max-width="1.5rem" class="ma-0 pa-0"
											src="@/assets/images/zoom_minus.png"></v-img>
										<v-slider class="zoom_control" min="10" max="40" step="1" dense 
											hide-details
											v-model="zoomScale" @input="setZoomScaleText(zoomScale)" 
											color="grey" track-color="grey" thumb-color="white">
										</v-slider>
										<v-img max-height="1.5rem" max-width="1.5rem" class="ma-0 pa-0"
											src="@/assets/images/zoom_plus.png"></v-img>
									</div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-col>
    </v-col>
  </v-container>
</template>

<script>
import mixin from '@/mixin';
import videoPlayerMixin from '@/views/player/mixin/index';
import 'video.js/dist/video-js.css';
import videojs from 'video.js';
import 'videojs-contrib-hls';
import $ from 'jquery';
import Panzoom from '@panzoom/panzoom';
import * as controlBar from '../player/buildControlBar';
import Header from './components/Header.vue';
import { floor } from 'lodash';

export default {
  components: {
		Header
	},
  mixins: [mixin.common, videoPlayerMixin],
  data: () => ({
    player: null,
    playerOptions: {
      controls: true,
      liveui: true,
      autoplay: 'muted',
      controlBar: {
      	pictureInPictureToggle : false,
      	progressControl : false,
      	children: []
      },
    },
    videoDuration: null,
    videoPlayStatus: false,
    videoStreamingUrl: '',
		zoomScale: 1,
		mouseZoomScroll: true,
  }),
  async mounted() {
    this.videoStreamingUrl = await this.$store.getters.getVideoStreamingUrl;
    this.streamData = await this.$store.getters.getStreamInfo;
    // console.log(this.videoStreamingUrl);
    this.buildVideoPlayer(this.videoStreamingUrl);
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
  watch: {
		zoomScale: function(zoom) {
			if(this.mouseZoomScroll == false) {
				$("#video1_html5_api").css({'-moz-transform': `scale(${zoom/10})`});
				$("#video1_html5_api").css({'-webkit-transform': `scale(${zoom/10})`});
				$("#video1_html5_api").css({'-o-transform': `scale(${zoom/10})`});
				$("#video1_html5_api").css({'-ms-transform': `scale(${zoom/10})`});
				$("#video1_html5_api").css({'-transform': `scale(${zoom/10})`});
			}
		},
  },
  methods: {
    buildVideoPlayer(videoStreamingUrl) {
      this.player = videojs(
        'video1',
        this.playerOptions,

        function onPlayerReady() {
          this.src({
            src: `${videoStreamingUrl}`,
            // src: 'https://s3.amazonaws.com/_bc_dml/example-content/sintel_dash/sintel_vod.mpd',
            // src: 'https://example.com/index.m3u8',
            type: 'application/x-mpegURL',
          });
          this.on('error', function (event) {
            console.log(event);
            var time = this.currentTime();
            if (this.error().code === 2) {
              this.error(null).pause().load().currentTime(time).play();
            }
          });
        }
      );

      this.player.one('loadedmetadata', () => {
        this.videoDuration = this.player.duration();
        console.log(`Duration of Video ${Math.floor(this.videoDuration)}s`);
        console.log(`Original Width of Video ${this.player.videoWidth()}`);
        this.videoPlayStatus = true;
      });
      
      const {ControlButton} = controlBar;
      controlBar.addFullScreenButton(this, ControlButton.FullScreenButton);
				controlBar.addSpacer(this, ControlButton.Spacer);
				controlBar.addVideoZoomButton(this, ControlButton.VideoZoom);
				controlBar.addSpacer(this, ControlButton.Spacer);
      
      const elem = document.getElementById('video1_html5_api');
      const panzoom = Panzoom(elem, {
        contain: 'outside',
      });
      elem.addEventListener('wheel', panzoom.zoomWithWheel);
      elem.addEventListener('click', (e) => {
				if (floor(panzoom.getScale(), 1) > 1.0) e.stopPropagation();
			}, true);
			elem.addEventListener('panzoomchange', (event) => {
				this.mouseZoomScroll = true;
				// console.log(event.detail.scale * 100) // => { x: 0, y: 0, scale: 1 }
				let scale = Math.floor(event.detail.scale * 100);
				this.zoomScale = Math.floor(scale / 10);
				if(scale < 100) this.zoomButtonDom.innerHTML = "<span id=\"zoomScaleText\">100%</span>";
				else this.zoomButtonDom.innerHTML = "<span id=\"zoomScaleText\">" + this.zoomScale * 10 + "%</span>";
			});
		  $("#zoom_change").appendTo($("#video1"));
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../player/videoPlayer.scss';
#video1 {
  width: 100%;
  height: 100%;
  border: 2px solid red;
  object-fit: contain;
}
::v-deep .vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {
	// ControlBar 항상 보이게 하는 옵션
  visibility: visible;
  opacity: 1;
  pointer-events: none;
  transition: visibility 1s, opacity 1s;
}
</style>
